"use client";

import { useEffect } from "react";

import "./fmcg-retail.css";

const Arrow = () => <span className="arrow">→</span>;

const svgProps = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

const IconLeaf = () => (
  <svg {...svgProps}>
    <path d="M5 21c8 0 14-6 14-14V4h-3C8 4 3 9 3 17v4z" />
    <path d="M5 21c3-3 6-6 14-14" />
  </svg>
);

const IconGear = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
  </svg>
);

const IconWarehouse = () => (
  <svg {...svgProps}>
    <path d="M3 10l9-6 9 6" />
    <path d="M5 9v11h14V9" />
    <path d="M9 20v-6h6v6" />
  </svg>
);

const IconTruck = () => (
  <svg {...svgProps}>
    <rect x="1" y="7" width="13" height="10" rx="1" />
    <path d="M14 10h4l3 3v4h-7z" />
    <circle cx="6" cy="19" r="1.6" />
    <circle cx="17" cy="19" r="1.6" />
  </svg>
);

const IconCart = () => (
  <svg {...svgProps}>
    <circle cx="9" cy="20" r="1" fill="currentColor" stroke="none" />
    <circle cx="18" cy="20" r="1" fill="currentColor" stroke="none" />
    <path d="M2 3h2l2.4 12.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7H6" />
  </svg>
);

const IconPeople = () => (
  <svg {...svgProps}>
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M15.5 14a5 5 0 0 1 5.5 5" />
  </svg>
);

const IconPerson = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
  </svg>
);

const IconFactory = () => (
  <svg {...svgProps}>
    <path d="M3 21V10l6 4v-4l6 4V8l6 4v9H3z" />
    <path d="M7 21v-4M12 21v-4M17 21v-4" />
  </svg>
);

const IconChart = () => (
  <svg {...svgProps}>
    <path d="M4 20V10M12 20V4M20 20v-7" />
  </svg>
);

const IconTag = () => (
  <svg {...svgProps}>
    <path d="M12 2h7a1 1 0 0 1 1 1v7a2 2 0 0 1-.6 1.4l-8 8a2 2 0 0 1-2.8 0l-6-6a2 2 0 0 1 0-2.8l8-8A2 2 0 0 1 12 2z" />
    <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

const IconBox = () => (
  <svg {...svgProps}>
    <path d="M21 8l-9-5-9 5 9 5 9-5z" />
    <path d="M3 8v8l9 5 9-5V8" />
    <path d="M12 13v8" />
  </svg>
);

const IconTarget = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const IconDocument = () => (
  <svg {...svgProps}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </svg>
);

const IconCrm = () => (
  <svg {...svgProps}>
    <path d="M12 2 3 12l9 10 9-10-9-10z" />
  </svg>
);

const IconEcommerce = () => (
  <svg {...svgProps}>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8M12 16v4" />
  </svg>
);

const IconMarket = () => (
  <svg {...svgProps}>
    <path d="M4 19V13M9 19V9M14 19V15M19 19V5" />
  </svg>
);

const IconDollar = () => (
  <svg {...svgProps}>
    <path d="M12 2v20" />
    <path d="M17 6.5c0-2-2-3.5-5-3.5s-5 1.7-5 3.8 2 3.2 5 3.7 5 1.9 5 3.7-2 3.8-5 3.8-5-1.5-5-3.5" />
  </svg>
);

const IconDatabase = () => (
  <svg {...svgProps}>
    <ellipse cx="12" cy="5" rx="8" ry="3" />
    <path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5" />
    <path d="M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" />
  </svg>
);

const IconLayers = () => (
  <svg {...svgProps}>
    <path d="M12 2 2 7l10 5 10-5-10-5z" />
    <path d="M2 12l10 5 10-5" />
    <path d="M2 17l10 5 10-5" />
  </svg>
);

const IconBulb = () => (
  <svg {...svgProps}>
    <path d="M9 18h6M10 22h4" />
    <path d="M12 2a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 2z" />
  </svg>
);

const IconArrowRight = () => (
  <svg {...svgProps}>
    <path d="M4 12h15M13 6l6 6-6 6" />
  </svg>
);

const IconArrowDown = () => (
  <svg {...svgProps}>
    <path d="M12 4v15M6 13l6 6 6-6" />
  </svg>
);

const IconStorefront = () => (
  <svg {...svgProps}>
    <path d="M3 9l1.5-5h15L21 9" />
    <path d="M4 9v10h16V9" />
    <path d="M4 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0" />
    <path d="M9 19v-6h6v6" />
  </svg>
);

const IconBag = () => (
  <svg {...svgProps}>
    <path d="M6 8h12l-1 12H7L6 8z" />
    <path d="M9 8V6a3 3 0 0 1 6 0v2" />
  </svg>
);

const ICONS = {
  leaf: IconLeaf,
  gear: IconGear,
  warehouse: IconWarehouse,
  truck: IconTruck,
  cart: IconCart,
  people: IconPeople,
  person: IconPerson,
  factory: IconFactory,
  chart: IconChart,
  tag: IconTag,
  box: IconBox,
  coins: IconTarget,
  document: IconDocument,
  crm: IconCrm,
  ecommerce: IconEcommerce,
  market: IconMarket,
  dollar: IconDollar,
  database: IconDatabase,
  layers: IconLayers,
  bulb: IconBulb,
  arrowRight: IconArrowRight,
  arrowDown: IconArrowDown,
  storefront: IconStorefront,
  bag: IconBag,
};

const Icon = ({ type }) => {
  if (type === "sap") {
    return <span className="custom-icon icon-sap sap-logo">SAP</span>;
  }

  const IconComponent = ICONS[type];
  if (!IconComponent) return null;

  return (
    <span className={`custom-icon icon-${type}`}>
      <IconComponent />
    </span>
  );
};

export default function FMCGRetailPage() {
  const questions = [
    "Which SKUs are growing or declining?",
    "Why is inventory increasing when sales aren’t?",
    "Which products will stock out?",
    "Where are we losing margin?",
    "Is growth coming from volume, price or mix?",
  ];

  const chainSteps = [
    {
      icon: "people",
      accent: "blue",
      title: "Consumer Demand",
      items: ["Market Trends", "Shopper Behaviour", "Channel Insights"],
    },
    {
      icon: "box",
      accent: "blue",
      title: "Source",
      items: ["Suppliers", "Raw Materials", "Contracts"],
    },
    {
      icon: "factory",
      accent: "orange",
      title: "Make",
      items: ["Plants", "Lines", "Output"],
    },
    {
      icon: "warehouse",
      accent: "purple",
      title: "Inventory",
      items: ["Stock", "Allocation", "Replenishment"],
    },
  ];

  const channelItems = [
    { icon: "cart", label: "General Trade" },
    { icon: "storefront", label: "Modern Trade" },
    { icon: "bag", label: "E-commerce" },
  ];

  const metrics = [
    { key: "green", icon: "chart", label: "REVENUE" },
    { key: "orange", icon: "gear", label: "MARGIN" },
    { key: "purple", icon: "dollar", label: "CASH" },
  ];

  const growthAreas = [
    {
      title: "Demand & S&OP",
      href: "/knowledge/supply-chain",
      text: "Forecast | Demand\nSupply | Scenario Planning",
      image: "/assets/images/sndop.png",
    },
    {
      title: "SKU & Portfolio",
      href: "/solutions",
      text: "Brand | Category\nPack | Mix",
      image: "/assets/images/sku-portfolio.jpg",
    },
    {
      title: "Inventory & Availability",
      href: "/solutions/inventory-intelligence",
      text: "Stock | Ageing\nReplenishment",
      image: "/assets/images/Inventory_availability.jpg",
    },
    {
      title: "Pricing & Schemes",
      href: "/solutions/margin",
      text: "Price | Discount\nPromotion | ROI",
      image: "/assets/images/pricing-schemes.jpg",
    },
    {
      title: "Customer & Channel",
      href: "/knowledge/customer&revenue",
      text: "Distributor | Outlet\nModern Trade |\nE-commerce",
      image: "/assets/images/customer-channel.jpg",
    },
    {
      title: "Margin & Working Capital",
      href: "/solutions/cash-working-capital",
      text: "COGS | Contributions\nReceivables | Working\nCapital",
      image: "/assets/images/margin-working-capital.jpg",
    },
  ];

  const systems = [
    { icon: "sap", title: "SAP", sub: "ERP" },
    { icon: "document", title: "DMS", sub: "" },
    { icon: "cart", title: "POS", sub: "" },
    { icon: "crm", title: "CRM", sub: "" },
    { icon: "gear", title: "WMS", sub: "" },
    { icon: "ecommerce", title: "E-COMMERCE", sub: "" },
    { icon: "market", title: "MARKET DATA", sub: "" },
  ];

  const bottomItems = [
    { icon: "leaf", title: "Better", sub: "Planning" },
    { icon: "gear", title: "Higher", sub: "Service Levels" },
    { icon: "coins", title: "Stronger", sub: "Margins" },
    { icon: "leaf", title: "Lower", sub: "Working Capital" },
    { icon: "people", title: "Happier", sub: "Consumers" },
    { icon: "chart", title: "Sustainable", sub: "Growth" },
  ];

  useEffect(() => {
    const cards = document.querySelectorAll(
      ".chain-col, .channel-bar, .metric-card, " +
      ".question-row, .growth-item, .system-box, .data-boxes > div, .benefit-item"
    );

    if (!("IntersectionObserver" in window)) {
      cards.forEach((card) => card.classList.add("in-view"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="fmcg-page">

      {/* ================= HERO ================= */}
      <section className="hero-section">

        <div className="hero-overlay"></div>

        <div className="hero-content">

          <div className="hero-left">

            <h1>
              From Every SKU to
              <br />
              Every Consumer.
            </h1>

            <h2>
              See What Drives Growth, Margin and Cash.
            </h2>

            <p>
              Orane connects products, customers, channels and supply chain
              <br className="desktop-break" />
              to help FMCG and retail businesses make better, faster decisions
            </p>

            <div className="hero-buttons">
              <a href="/tellusyourproblem#tell-details" className="primary-btn">
                Tell Us Your Challenge <Arrow />
              </a>

              <a href="#how-it-works" className="secondary-btn">
                See How It Works
                <span className="play-icon">▶</span>
              </a>
            </div>

          </div>

        </div>


        {/* VALUE CHAIN */}
        <div className="value-chain">

          <div className="chain-item">
            <div className="chain-circle">
              <Icon type="leaf" />
            </div>
            <span>RAW MATERIALS</span>
            <small>& SUPPLIERS</small>
          </div>

          <div className="chain-item">
            <div className="chain-circle">
              <Icon type="gear" />
            </div>
            <span>MANUFACTURING</span>
            <small>& PACKAGING</small>
          </div>

          <div className="chain-item">
            <div className="chain-circle">
              <Icon type="warehouse" />
            </div>
            <span>WAREHOUSE</span>
            <small>& INVENTORY</small>
          </div>

          <div className="chain-item">
            <div className="chain-circle">
              <Icon type="truck" />
            </div>
            <span>DISTRIBUTION</span>
            <small>& LOGISTICS</small>
          </div>

          <div className="chain-item">
            <div className="chain-circle">
              <Icon type="cart" />
            </div>
            <span>CHANNELS</span>
            <small>& CUSTOMERS</small>
          </div>

        </div>

      </section>


      {/* ================= QUESTIONS ================= */}
      <section className="content-section">

        <div className="white-card questions-card">

          <div className="questions-content">

            <h2>
              Top Questions <span>FMCG Leaders Ask</span>
            </h2>

            <p className="section-subtitle">
              Real questions. Real decisions.
            </p>

            <div className="questions-list">

              {questions.map((question, index) => (
                <div className="question-row" key={question}>

                  <div className="number">
                    {index + 1}
                  </div>

                  <span>{question}</span>

                  <span className="question-chevron">›</span>

                </div>
              ))}

            </div>

            <a href="/52problem" className="more-link">
              See More Questions <Arrow />
            </a>

          </div>

          <div className="questions-image">
            <img src="/assets/images/fmcg1.png" alt="FMCG & Retail" />
          </div>

        </div>

      </section>


      {/* ================= ENTERPRISE FLOW ================= */}
      <section className="content-section" id="how-it-works">

        <div className="white-card enterprise-card">

          <div className="enterprise-content">

            <h2>
              The FMCG Enterprise <span className="accent-blue">in Motion</span>
            </h2>

            <p className="section-subtitle">
              From consumer demand to cash.
            </p>

            <div className="chain-grid">

              {chainSteps.map((step) => (
                <div className={`chain-col chain-col-${step.accent}`} key={step.title}>

                  <div className="chain-col-head">
                    <span className="chain-icon">
                      <Icon type={step.icon} />
                    </span>
                  </div>

                  <strong>{step.title}</strong>

                  <ul className="chain-list">
                    {step.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                </div>
              ))}

            </div>

            <div className="channel-bar">

              <span className="channel-bar-icon">
                <Icon type="storefront" />
              </span>

              <div className="channel-bar-main">

                <strong>
                  Distributor &nbsp;|&nbsp; Outlet &nbsp;|&nbsp; Channel
                </strong>

                <div className="channel-bar-items">

                  {channelItems.flatMap((item, index) => {
                    const nodes = [
                      <span className="channel-bar-item" key={item.label}>
                        <Icon type={item.icon} />
                        {item.label}
                      </span>,
                    ];

                    if (index < channelItems.length - 1) {
                      nodes.push(
                        <span className="channel-bar-divider" key={`div-${item.label}`} aria-hidden="true"></span>
                      );
                    }

                    return nodes;
                  })}

                </div>

              </div>

            </div>

            <div className="metrics-row">

              {metrics.map((metric) => (
                <div className={`metric-card metric-${metric.key}`} key={metric.label}>
                  <span className="metric-icon">
                    <Icon type={metric.icon} />
                  </span>
                  <strong>{metric.label}</strong>
                </div>
              ))}

            </div>

          </div>

          <div className="enterprise-image">
            <img src="/assets/images/fmcg_retail.jpg" alt="FMCG retail store" />
          </div>

        </div>

      </section>


      {/* ================= KEY GROWTH AREAS ================= */}
      <section className="content-section">

        <div className="white-card growth-card">

          <h2>
            Key Growth Areas Across the <span>Value Chain</span>
          </h2>

          <p className="section-subtitle">
            Six connected lenses. One integrated view.
          </p>

          <div className="growth-grid">

            {growthAreas.map((item) => (
              <a
                href={item.href}
                className="growth-item"
                key={item.title}
                style={{ backgroundImage: `url("${item.image}")` }}
              >

                <div className="growth-item-overlay"></div>

                <div className="growth-item-content">
                  <strong>{item.title}</strong>

                  <p>
                    {item.text.split("\n").map((line, i) => (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                </div>

                <span className="growth-item-arrow">
                  <Icon type="arrowRight" />
                </span>

              </a>
            ))}

          </div>

        </div>

      </section>


      {/* ================= ENTERPRISE SYSTEMS & DATA ================= */}
      <section className="content-section content-section-last">

        <div className="white-card systems-card">

          <h2>
            Enterprise Systems & <span>Data</span>
          </h2>

          <p className="section-subtitle">
            Bring data together. Turn insights into action.
          </p>

          <div className="systems-grid">

            {systems.map((system) => (
              <div className="system-box" key={system.title}>
                <Icon type={system.icon} />
                <span className="system-box-label">
                  <strong>{system.title}</strong>
                  {system.sub && <small>{system.sub}</small>}
                </span>
              </div>
            ))}

          </div>

          <div className="data-boxes">

            <div>
              <Icon type="database" />
              <div className="data-box-text">
                <strong>Trusted FMCG Data</strong>
                <span>Transactional | Master | External</span>
              </div>
            </div>

            <div>
              <Icon type="layers" />
              <div className="data-box-text">
                <strong>Industry Semantics</strong>
                <span>
                  Products | Channels | Trade | Schemes | Market Context
                </span>
              </div>
            </div>

            <div>
              <Icon type="bulb" />
              <div className="data-box-text">
                <strong>FMCG Intelligence</strong>
                <span>
                  Analytics | AI | Scenarios | Recommendations
                </span>
              </div>
            </div>

          </div>

        </div>

      </section>


      {/* ================= FINAL CTA ================= */}
      <section className="bottom-section">

        <div className="bottom-inner">

          <div className="bottom-title">

            <h2>
              Every SKU <span>Tells a Story.</span>
            </h2>

            <p>
              Turn complexity into real value.
            </p>

            <a href="/tellusyourproblem#tell-details" className="primary-btn">
              Tell Us Your FMCG & Retail Challenge <Arrow />
            </a>

          </div>


          <div className="bottom-benefits">

            {bottomItems.map((item) => (
              <div className="benefit-item" key={item.title + item.sub}>

                <Icon type={item.icon} />

                <span>
                  {item.title}
                  <br />
                  {item.sub}
                </span>

              </div>
            ))}

          </div>

        </div>

      </section>

    </main>
  );
}